import { useTranslation } from "react-i18next";
import { PackageOpen } from "lucide-react";
import { useFormContext } from "react-hook-form";
import { AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";
import { ControlledCheckbox } from "@/components/ui/customs/controlled-checkbox";
import { ControlledCustomTextarea } from "@/components/ui/customs/controlled-custom-textarea";

type PackagingInstructionsFormFields = {
  packagingInstructions?: string;
  packagingPriority: boolean;
};

export const PackagingInstructionsSection = () => {
  const { t } = useTranslation("boExpeditionForm");
  const methods = useFormContext<PackagingInstructionsFormFields>();

  return (
    <AccordionItem
      value="packagingInstructions"
      className="shadow-basic flex w-full max-w-[1400px] flex-col items-start justify-center gap-4 rounded-xl border border-gray-200 bg-slate-100 p-6"
    >
      <AccordionTrigger className="flex w-full flex-row items-start justify-between gap-2 self-start !no-underline">
        <div className="flex flex-row items-center gap-2 self-start">
          <PackageOpen className="h-6 w-6 !rotate-0 text-blue-600" />
          <p className="text-xl font-bold">{t("packagingInstructions.title")}</p>
        </div>
      </AccordionTrigger>
      <AccordionContent forceMount className="flex w-full flex-col gap-3">
        <ControlledCustomTextarea
          label={t("packagingInstructions.instructionsLabel")}
          control={methods.control}
          name="packagingInstructions"
          className="w-full"
          rows={4}
        />
        <ControlledCheckbox
          control={methods.control}
          name="packagingPriority"
          label={t("packagingInstructions.priorityLabel")}
        />
      </AccordionContent>
    </AccordionItem>
  );
};
